import * as React from 'react';
import * as styles from './CreditCardTypeIcon.scss';

export default (props: any) => (
  <div>
    <img className={styles.creditCardTypeIcon} src={`https://www.wix.com/_partials/third-party/cashier-settings/images/${props.cardType}.svg`} />
  </div>
);



// WEBPACK FOOTER //
// ./components/icons/CreditCardTypeIcon/CreditCardTypeIcon.tsx